import React from 'react'
import styled from 'styled-components'
import Text from '../../utils/Text'
import media from '../../utils/media'
import Image from './Image'
import BodyText from './BodyText'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 350px;
  margin-bottom: 80px;
  &:nth-child(odd) {
    flex-direction: row-reverse;
  }
  ${media.laptop`
    margin-bottom: 40px;
    height: 100%;
    min-height: 300px;
  `}
  ${media.tablet`
    flex-direction: column;
    height: auto;
    min-height: 254px;
    & > div:first-child {
      margin-bottom: 20px;
    }
  `}
`

const ImgWrapper = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${media.laptop`
    display: flex;
    align-items: center;
    padding: 0 10px;
  `}
  ${media.tablet`
    display: none;
  `}
`

const TxtWrapper = styled.div`
  width: 50%;
  max-width: 434px;
  height: 350px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${media.laptop`
    height: 100%;
    padding: 0 19px;
  `}
  ${media.tablet`
    width: 100%;
    max-width: 100%;
    padding: 0 15px;
  `}
`

const Title = styled.div`
  margin-bottom: 18px;
  p {
    font-size: 32px;
    line-height: 1.23;
    em {
      font-style: normal;
      color: ${props => props.accent};
    }
  }
  ${media.tablet`
    p {
      font-size: 26px;
    }
  `}
`

const List = styled.ul`
  font-family: ${props =>
    props.fontFamily ? props.fontFamily : 'Raleway'};
  font-size: ${props => (props.textSize ? props.textSize : '16')}px;
  list-style: none;
  margin-bottom: 0px !important;
  -webkit-padding-start: 0;
  li {
    line-height: 1.44;
    span {
      display: inline !important;
    }
    &:before {
      content: '·';
      padding-right: 5px;
    }
    &:last-child {
      margin-bottom: 20px !important;
    }
  }
  li:empty {
    display: none;
  }
`

export default function ImageText({
  src,
  alt,
  maxWidth,
  minWidth,
  accent,
  title,
  marginBText,
  text,
  textList,
  textTwo,
  fontFamily,
  textSize,
}) {
  const listItems = Object.values(textList)

  return (
    <Container>
      <ImgWrapper>
        <Image
          src={src}
          alt={alt}
          maxWidth={maxWidth}
          minWidth={minWidth}
        />
      </ImgWrapper>
      <TxtWrapper>
        <Title accent={accent}>
          <Text id={title} markdown />
        </Title>
        {text && (
          <BodyText
            text={text}
            marginBText={marginBText}
            fontFamily={fontFamily}
            textSize={textSize}
          />
        )}
        <List fontFamily={fontFamily} textSize={textSize}>
          {listItems.map(el => {
            return (
              <li key={el}>
                <Text id={el} />
              </li>
            )
          })}
        </List>
        <BodyText
          text={textTwo}
          marginBText={marginBText}
          fontFamily={fontFamily}
          textSize={textSize}
        />
      </TxtWrapper>
    </Container>
  )
}
